import { createFileRoute } from "@tanstack/react-router"
import { ContentResourcesPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/content/resources"
)({
  component: () => (
    <AuthorizationGate resource={Resource.CONTENT} action={Action.READ}>
      <ContentResourcesPage />
    </AuthorizationGate>
  ),
})
